import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLoaderData } from "react-router";

import "../../assets/css/majorybl/pages/leagues.scss";
import Schedule from "../../components/Schedule";
import { getTeamSchedule } from "../../lib/api";
import { IAPIResponse, ITeamSchedule } from "../../types/api";

export const loader = async ({ params }: any) => {
    const { schedule } = await getTeamSchedule(params.leagueId, params.teamId);
    let header: string = "";

    if (schedule) {
        const { teamName, ageLevel, designation, direction } = schedule;
        header = `${teamName} (${ageLevel}${
            designation ? " " + designation : ""
        }${direction ? " " + direction : ""}) Home`;
    } else {
        header = "Team Home";
    }

    return {
        schedule,
        header,
    };
};

const LeagueTeam = (): React.JSX.Element => {
    const {
        schedule: { schedule },
    } = useLoaderData() as {
        schedule: IAPIResponse & { schedule: ITeamSchedule };
    };

    return (
        <div data-testid="teamScheduleContent">
            <Container fluid="xs">
                <Row>
                    <Col>
                        <Schedule
                            schedule={
                                schedule?.games
                                    ? schedule.games.filter(g =>
                                          ["Scheduled", "Rescheduled"].includes(
                                              g.status,
                                          ),
                                      )
                                    : null
                            }
                            scheduleType="team"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default LeagueTeam;
